import { render, staticRenderFns } from "./BopSetup.vue?vue&type=template&id=1900e626"
import script from "./BopSetup.vue?vue&type=script&lang=ts"
export * from "./BopSetup.vue?vue&type=script&lang=ts"
import style0 from "./BopSetup.vue?vue&type=style&index=0&id=1900e626&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports